import React from 'react';
import {connect} from 'react-redux';
import { concatStudentNames } from '../../../../../utilities/common';
import {isEmpty} from '../../../../../utilities/validation';
var getLang = function () {
  var l = localStorage.getItem('stuLang');
  return l ? l : 'en';
};

var t = function (enText, esText) {
  var lang = getLang();
  return lang === 'es' ? esText : enText;
};
var translateAssessmentName = function(name) {
  if (!name) return '';

  var lower = name.toLowerCase();

  if (lower === 'module guide') return 'Guía del módulo';
  if (lower === 'post test') return 'Prueba final';
  if (lower === 'engagement survey') return 'Encuesta de participación';
  if (lower.indexOf('pop quiz') !== -1) {
    return name.replace('Pop Quiz', 'Cuestionario');
  }
  if (lower.indexOf('rca') !== -1) {
    return name; // keep RCA as-is
  }

  return name;
};
class PreAssessmentPage extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {name='', activeUser, waitingUser, doneUser, users={}, isPrePost, multiStudentRca, finalUserPrePost } = this.props;
        let studentNames = '';
        if (!isEmpty(users) && users.length > 0) {
            studentNames = concatStudentNames(users);
        }

        return (
            <div>
                {!isEmpty(activeUser) &&
                <div>
                    <div className="node assessment-top-container">
                        {/*single student RCA*/}
                        {!multiStudentRca && !isPrePost &&
                        <div>
                            <h2>
                                {activeUser.firstName} {activeUser.lastName}, {t('click Continue to take the','haz clic en Continuar para tomar el')} {getLang() === 'es' ? translateAssessmentName(name) : name}.
                                {t('Click Cancel to return to the Session Selector.','Haga clic en Cancelar para volver al Selector de Sesiones.')}
                            </h2>
                            <h2>
                                {t('In order to continue with this session, you must complete the','Para continuar con esta sesión, debes completar el')} {getLang() === 'es' ? translateAssessmentName(name) : name}.
                            </h2>
                        </div>
                        }

                        {/*multi-student RCA*/}
                        {multiStudentRca &&
                        <div>
                            <h2>
                                {studentNames}, {t('click Continue to take the','haz clic en Continuar para tomar el')} {getLang() === 'es' ? translateAssessmentName(name) : name}.
                                {t('Click Cancel to return to the Session Selector.','Haga clic en Cancelar para volver al Selector de Sesiones.')}
                            </h2>
                            <h2>
                                {t('In order to continue with this session, you must complete the','Para continuar con esta sesión, debes completar el')} {getLang() === 'es' ? translateAssessmentName(name) : name}.
                            </h2>
                        </div>
                        }

                        {/*single-user PrePost*/}
                        {isPrePost && finalUserPrePost && isEmpty(doneUser) &&
                        <h2>
                            {activeUser.firstName} {activeUser.lastName},
                            {t('you are going to complete the','vas a completar el')} {getLang() === 'es' ? translateAssessmentName(name) : name} {t('at this time. Please click Continue to begin.','en este momento. Por favor, haga clic en Continuar para comenzar.')}
                        </h2>
                        }

                        {/*multi-user PrePost starting screen*/}
                        {(isPrePost && !finalUserPrePost) &&
                        <div>
                            <h2>
                                {activeUser.firstName} {activeUser.lastName},
                                {t('you are going to complete the','vas a completar el')} {getLang() === 'es' ? translateAssessmentName(name) : name} {t('at this time. Please click Continue to begin.','en este momento. Por favor, haga clic en Continuar para comenzar.')}
                            </h2>
                            <h2>
                                {waitingUser.firstName} {waitingUser.lastName},
                                {t('please read from the Module library while your partner completes the','por favor lee de la biblioteca del módulo mientras tu compañero completa el')} {getLang() === 'es' ? translateAssessmentName(name) : name}.
                            </h2>
                        </div>
                        }

                        {/*multi-user PrePost halfway screen*/}
                        {(isPrePost && !isEmpty(doneUser)) &&
                        <div>
                            <h2>
                                {doneUser.firstName} {doneUser.lastName},
                                {t('you have finished the','has terminado el')} {getLang() === 'es' ? translateAssessmentName(name) : name}. {t('It is now your turn to read from the Module library.','Ahora es tu turno de leer de la biblioteca del módulo.')}
                            </h2>

                            <h2>
                                {activeUser.firstName} {activeUser.lastName},
                                {t('you are going to complete the','vas a completar el')} {getLang() === 'es' ? translateAssessmentName(name) : name} {t('at this time. Please click Continue to begin.','en este momento. Por favor, haga clic en Continuar para comenzar.')}
                            </h2>

                        </div>
                        }

                    </div>

                    <div className="node assessment-bottom-container">
                        {!isEmpty(waitingUser) &&
                        <button className="assessment-cancel" onClick={this.props.exitViewer}/>
                        }
                        <button className={t('assessment-continue','assessment-continue-spanish')} onClick={this.props.startAssessment} />
                    </div>
                </div>
                }
            </div>
        );
    }
}

// {!isEmpty(waitingUser) &&
//     }
const mapStateToProps = (state) => {
//   console.log(state);
    const {currentMyAssignment = {}} = state.auth.assignment;
    const {users = {}, user = {}} = state.auth;
    return {
        currentMyAssignment,
        role: users[0].role,
        users: users,
    };
};

const PreAssessment = connect(
    mapStateToProps,
    null
)(PreAssessmentPage);

export default PreAssessment;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/assessment/pre-assessment.js